import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActionType, CampaignProduct, getCampaignProductImageUrl, ImageSize, UpsaleType } from '../../../_models';
import { AlertService, CampaignProductService } from '../../../_services';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Form } from '../../../_forms';

@Component({
  selector: 'step-upsale-product',
  templateUrl: './step-upsale-product.component.html',
  styleUrls: ['./step-upsale-product.component.scss'],
})
export class StepUpsaleProductComponent extends Form implements OnInit {
  @Input() actionList: FormArray;
  @Input() baseAction: FormGroup;
  @Input() formIndex: number | string;

  upsaleActions: FormGroup;
  upsaleType: UpsaleType = UpsaleType.None;
  upsaleTypes: any[] = [
    { value: UpsaleType.None, label: 'None' },
    { value: UpsaleType.Fixed, label: 'Fixed' },
    { value: UpsaleType.Index, label: 'Index' },
  ];
  upsaleIndexList = [
    { value: 0, label: '1st Upsell Product' },
    { value: 1, label: '2nd Upsell Product' },
    { value: 2, label: '3rd Upsell Product' },
    { value: 3, label: '4th Upsell Product' },
    { value: 4, label: '5th Upsell Product' },
  ];
  selectedCampaignProduct: CampaignProduct = null;
  private tempSelectedCampaignProduct: CampaignProduct = null;
  productLoading = false;

  constructor(
    protected campaignProductService: CampaignProductService,
    protected modalService: NgxSmartModalService,
    private formBuilder: FormBuilder,
    protected router: Router,
    protected location: Location,
    protected alertService: AlertService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    const upsaleActionIndex = this.actionList.controls.findIndex((action) => {
      const actionValue = action.value;
      return (
        actionValue && actionValue.resourcetype === ActionType.AddProduct && actionValue.hasOwnProperty('upsale_index')
      );
    });

    if (upsaleActionIndex > -1) {
      const upsaleAction = this.actionList.at(upsaleActionIndex);
      this.initializeUpsaleAction(upsaleAction.value, upsaleActionIndex);
    }
  }

  private initializeUpsaleAction(existingAction?: any, actionIndex?: number) {
    const values = existingAction || {};
    const formControls: any = {
      upsale_index: [values.upsale_index !== undefined ? values.upsale_index : null],
      campaign_product: [values.campaign_product || null],
      price: [values.price !== undefined ? values.price : null],
      shipping_price: [values.shipping_price !== undefined ? values.shipping_price : null],
      execution_type: [
        values.execution_type !== undefined ? values.execution_type : this.baseAction.get('execution_type').value,
      ],
      holdoff_delay: [
        values.holdoff_delay !== undefined ? values.holdoff_delay : this.baseAction.get('holdoff_delay').value,
      ],
      resourcetype: [values.resourcetype || ActionType.AddProduct],
    };

    // Only include these properties if we have an existing action
    if (existingAction) {
      formControls.id = [values.id];
      formControls.requires_active_item = [values.requires_active_item];
      formControls.requires_customer = [values.requires_customer];
      formControls.requires_item = [values.requires_item];
    }

    this.upsaleActions = this.formBuilder.group(formControls);

    if (actionIndex !== undefined && actionIndex > -1) {
      this.actionList.setControl(actionIndex, this.upsaleActions);
    } else {
      this.actionList.push(this.upsaleActions);
    }

    const campaignProduct = this.upsaleActions.value.campaign_product;
    const upsaleIndex = this.upsaleActions.value.upsale_index;

    if (campaignProduct) {
      this.upsaleType = UpsaleType.Fixed;
      this.productLoading = true;
      this.campaignProductService.get(campaignProduct).subscribe({
        next: (product: CampaignProduct) => {
          this.productLoading = false;
          this.selectedCampaignProduct = product;
        },
        error: (error) => {
          this.productLoading = false;
          this.handleError(error);
        },
      });
    } else if (upsaleIndex !== null && upsaleIndex !== undefined) {
      this.upsaleType = UpsaleType.Index;
    }
  }

  selectProduct() {
    this.modalService.getModal('selectUpsaleProductDialog').open();
  }

  onProductSelected(product: CampaignProduct) {
    this.selectedCampaignProduct = product;
    this.upsaleActions.get('campaign_product').setValue(product.id);
    this.modalService.getModal('selectUpsaleProductDialog').close();
  }

  get isUpsaleTypeIndex() {
    return this.upsaleType === UpsaleType.Index;
  }

  get isUpsaleTypeFixed() {
    return this.upsaleType === UpsaleType.Fixed;
  }

  selectUpsaleType(type: UpsaleType) {
    this.upsaleType = type;

    // Find and remove existing upsale action
    const upsaleActionIndex = this.actionList.controls.findIndex((action) => {
      const actionValue = action.value;
      return (
        actionValue && actionValue.resourcetype === ActionType.AddProduct && actionValue.hasOwnProperty('upsale_index')
      );
    });

    if (upsaleActionIndex > -1) {
      this.actionList.removeAt(upsaleActionIndex);
    }

    if (type !== UpsaleType.None) {
      this.initializeUpsaleAction();

      if (type === UpsaleType.Fixed) {
        if (!this.selectedCampaignProduct && !this.tempSelectedCampaignProduct) {
          this.selectProduct();
        } else if (this.tempSelectedCampaignProduct) {
          this.selectedCampaignProduct = this.tempSelectedCampaignProduct;
          this.upsaleActions.patchValue({
            campaign_product: this.selectedCampaignProduct.id,
          });
        }
      } else {
        this.tempSelectedCampaignProduct = this.selectedCampaignProduct;
        this.selectedCampaignProduct = null;
      }
    }
  }

  getProductImageUrl() {
    return getCampaignProductImageUrl(this.selectedCampaignProduct, ImageSize.medium);
  }
}
